import { Link } from "react-router-dom";

export function Logo({ dark = false }) {
  return (
    <Link to="/" data-testid="brand-logo" className="inline-flex items-center" aria-label="EL Well home">
      <img
        src={dark ? "/assets/logo-light.png" : "/assets/logo.png"}
        alt="EL Well™"
        className="h-7 w-auto sm:h-8"
      />
    </Link>
  );
}
